import React from 'react';
import { Box, Drawer } from '@mui/material';
import RetractionFeesForm from '../../../project/ticket/ActionPane/Orders/Retractions/RetractionFeesForm.jsx';
import useOrderDetails from '../../../../hooks/project/useOrderDetails.js';
import Spinner from '../../../utils/common/Spinner.jsx';

export const RetractDrawer = ({ data, isOpen, onClose }) => {
  const { orderDetails, isLoading } = useOrderDetails(data?._id);
  return (
    <Box>
      <Drawer
        sx={{
          '& .MuiDrawer-paper': {
            width: '50vw',
            padding: 2,
          },
          flexShrink: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
        anchor="right"
        open={isOpen}
        onClose={onClose}
      >
        {isLoading ? (
          <Spinner />
        ) : (
          <RetractionFeesForm
            orderDetails={orderDetails}
            handleShowComponent={onClose}
            isFromDrawwer={true}
            getRetractionFees={() => {}}
          />
        )}
      </Drawer>
    </Box>
  );
};
